// Moved to @hyperframes/parsers. Re-exported here for back-compat.
export { decodeUrlPathVariants } from "@hyperframes/parsers";
